<template>
  <button class="gc-popup__button-close" v-on="$listeners"   @click="hide()">
    <svg width="20" height="20" viewBox="0 0 25 25" fill=""
         xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.8811 12.5L24.714 1.66715C25.0954 1.28575 25.0954 0.667394 24.714 0.286047C24.3326 -0.0953001 23.7142 -0.0953489 23.3329 0.286047L12.5 11.1189L1.66715 0.286047C1.28575 -0.0953489 0.667394 -0.0953489 0.286047 0.286047C-0.0953001 0.667443 -0.0953489 1.2858 0.286047 1.66715L11.1189 12.5L0.286047 23.3329C-0.0953489 23.7143 -0.0953489 24.3326 0.286047 24.714C0.47672 24.9047 0.726671 25 0.976622 25C1.22657 25 1.47647 24.9047 1.6672 24.714L12.5 13.8811L23.3328 24.714C23.5235 24.9047 23.7735 25 24.0234 25C24.2734 25 24.5233 24.9047 24.714 24.714C25.0954 24.3326 25.0954 23.7142 24.714 23.3329L13.8811 12.5Z"
        fill="white"/>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'PopupButtonClose',
  methods: {
    hide () {
      this.$emit('hide')
      this.$emit('click')
    }
  }
}
</script>

<style scoped>

</style>
